module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bpaNd"))).then(() => parcelRequire('hEqeo'));